var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import { Link } from "react-router-dom";
import { useGetEmailsQuery } from "@/store/api";
/** <b>Composant en mode consultation/detail d'un champ de type email</b>*/
export default function EmailFieldDetail(_a) {
    var _b;
    var record = _a.record, fieldName = _a.fieldName, moduleName = _a.moduleName;
    var listEmails = useGetEmailsQuery({
        recordId: record.id,
        moduleName: moduleName,
    }).data;
    var value = useMemo(function () {
        var _a;
        if (!record) {
            return;
        }
        return (_a = listEmails === null || listEmails === void 0 ? void 0 : listEmails.data) === null || _a === void 0 ? void 0 : _a.prefillData;
    }, [listEmails, record]);
    var values = typeof record["email1"] === "object" ? record["email1"] : value;
    return (_jsx("div", { children: _jsx("ul", { children: values &&
                ((_b = values === null || values === void 0 ? void 0 : values.filter(function (element) { return !element.deleted; })) === null || _b === void 0 ? void 0 : _b.map(function (item, index) { return (_jsx(Link, __assign({ to: "mailto:".concat(item.email_address), onClick: function (e) {
                        window.location.href = "mailto:".concat(item.email_address);
                        e.preventDefault();
                    }, className: "" }, { children: _jsx("div", { children: _jsxs("li", { children: [_jsx("span", __assign({ className: "text-[rgb(var(--color-blue-400))] hover:text-blue-600" }, { children: item.email_address })), " ", item.primary_address ? (_jsx("span", __assign({ className: "italic text-[var(--colors-label)]" }, { children: "(primary)" }))) : ("")] }, item) }) }), index)); })) }) }));
}
